import { render, staticRenderFns } from "./RequestUnassign.vue?vue&type=template&id=bd925b16"
import script from "./RequestUnassign.vue?vue&type=script&lang=js"
export * from "./RequestUnassign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports